const CNPJ_LEGAL_SUFFIXES = new Set(['ltda', 'sa', 's/a', 's-a', 'me', 'epp', 'eireli', 'mei'])

const PT_CONNECTORS = new Set(['e', 'de', 'do', 'da', 'dos', 'das', 'em', 'para', 'por'])

const ELLIPSIS = '...'

export const PROCESS_FALLBACK = 'este processo'

const DEFAULT_CNPJ_MAX = 32
const DEFAULT_PROCESS_MAX = 80

export function firstWord(name: string): string {
  if (!name) return ''
  const trimmed = name.trim()
  if (!trimmed) return ''
  const space = trimmed.indexOf(' ')
  return space === -1 ? trimmed : trimmed.slice(0, space)
}

export function truncateCnpjName(name: string, max: number = DEFAULT_CNPJ_MAX): string {
  if (!name) return ''
  const trimmed = name.trim().replace(/\s+/g, ' ')
  if (!trimmed) return ''

  const words = trimmed.split(' ')
  while (words.length > 1 && CNPJ_LEGAL_SUFFIXES.has(words[words.length - 1].toLowerCase())) {
    words.pop()
  }

  const stripped = words.join(' ')
  if (stripped.length <= max) return stripped

  const budget = max - ELLIPSIS.length
  let result = ''
  for (const word of words) {
    const next = result ? `${result} ${word}` : word
    if (next.length > budget) break
    result = next
  }

  if (!result) {
    return words[0].slice(0, budget) + ELLIPSIS
  }

  const final = result.split(' ')
  while (final.length > 1 && PT_CONNECTORS.has(final[final.length - 1].toLowerCase())) {
    final.pop()
  }

  return final.join(' ') + ELLIPSIS
}

export function truncateProcessName(name: string, max: number = DEFAULT_PROCESS_MAX): string {
  if (!name) return PROCESS_FALLBACK
  const trimmed = name.trim().replace(/\s+/g, ' ')
  if (!trimmed) return PROCESS_FALLBACK
  if (trimmed.length <= max) return trimmed
  return PROCESS_FALLBACK
}
